<template>
  <div class="remote-files">
    <!-- 首屏 banner -->
    <div class="section-banner">
      <div class="banner-main">
        <div class="banner-row">
          <div class="banner-left">
            <div class="banner-title move">远程文件</div>
            <div class="banner-subtitle move delay-100"">随时随地访问你的文件</div>
            <div class="banner-desc move delay-200">
              可在节点小宝客户端中访问远程设备的文件，支持预览、下载或将远程文件挂载为系统磁盘，体验如本地。
            </div>
            <div class="banner-btns">
              <div class="btn-primary" @click="goDownload">立即体验</div>
              <div class="btn-ghost" @click="goDoc">查看文档</div>
            </div>
          </div>
          <img class="banner-pic" :src="bannerPic" alt="" />
        </div>
        <div class="banner-features">
          <div class="feature-item">
            <img class="feature-icon" :src="featXplatform" alt="" />
            <div class="feature-text">
              <div class="feature-title">跨平台连接</div>
              <div class="feature-sub">多端随时访问文件与目录</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="featMount" alt="" />
            <div class="feature-text">
              <div class="feature-title">远程挂载</div>
              <div class="feature-sub">Windows / macOS支持挂载到本地</div>
            </div>
          </div>
          <div class="feature-item">
            <img class="feature-icon" :src="featSafe" alt="" />
            <div class="feature-text">
              <div class="feature-title">隐私安全</div>
              <div class="feature-sub">仅通过加密通道传输</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 核心能力 -->
    <div class="section-adv">
      <div class="adv-main">
        <div class="section-title move">核心优势</div>
        <div class="section-sub move delay-100">轻松管理多节点网络</div>
        <div class="adv-grid">
          <div class="adv-card move" v-for="(item, index) in advList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <img class="adv-icon" :src="item.icon" alt="" />
            <div class="adv-title">{{ item.title }}</div>
            <div class="adv-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 工作原理 -->
    <div class="section-flow">
      <div class="flow-main">
        <div class="section-title move">工作原理</div>
        <div class="section-sub move delay-100">极致简单，安全访问</div>
        <div class="flow-grid">
          <template v-for="(item, index) in flowList">
            <div class="flow-card move" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
              <div class="flow-top">
                <img :src="item.img" alt="" />
              </div>
              <div class="flow-title">{{ item.title }}</div>
              <div class="flow-desc">{{ item.desc }}</div>
            </div>
            <div v-if="index < flowList.length - 1" class="flow-arrow" :key="'arrow-' + index">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                <path d="M8 8l6 7-6 7" stroke="#3772ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16 8l6 7-6 7" stroke="#3772ff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 使用方式（深色区） -->
    <div class="section-usage">
      <div class="usage-main">
        <div class="section-title move gradient-title">使用方式</div>
        <div class="usage-grid">
          <div class="usage-card move" v-for="(item, index) in usageList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <div class="usage-illus">
              <img :src="item.img" alt="" />
            </div>
            <div class="usage-title">{{ item.title }}</div>
            <div class="usage-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="section-scene">
      <div class="scene-main">
        <div class="section-title move">应用场景</div>
        <div class="scene-grid">
          <div class="scene-card move" v-for="(item, index) in sceneList" :key="item.title" :style="{ transitionDelay: index * 0.1 + 's' }">
            <div class="scene-img-wrap">
              <img :src="item.img" alt="" />
            </div>
            <div class="scene-title">{{ item.title }}</div>
            <div class="scene-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 CTA -->
    <div class="section-cta">
      <img class="cta-overlay" :src="ctaOverlay" alt="" />
      <div class="cta-main">
        <div class="cta-title">开启你的远程文件体验</div>
        <div class="cta-sub">让设备中的文件随时可达，访问便捷，传输高效，管理安全</div>
        <div class="btn-primary cta-btn" @click="goDownload">免费体验</div>
      </div>
    </div>

    <Foot></Foot>
  </div>
</template>

<script>
import Foot from '@/components/Foot.vue'

export default {
  name: 'RemoteFiles',
  components: {
    Foot,
  },
  data: function () {
    return {
      bannerPic: require('@/assets/remote_files/banner.webp'),
      featXplatform: require('@/assets/remote_files/feat_xplatform.png'),
      featMount: require('@/assets/remote_files/feat_mount.png'),
      featSafe: require('@/assets/remote_files/feat_safe.png'),
      ctaOverlay: require('@/assets/introduce/cta_bg.png'),
      advList: [
        {
          icon: require('@/assets/remote_files/adv_files.png'),
          // 快捷预览：远程浏览文件与目录
          title: '快捷预览',
          desc: '远程浏览文件与目录',
        },
        {
          icon: require('@/assets/remote_files/adv_upload.png'),
          // 极速下载：最高可达带宽上行速率
          title: '极速下载',
          desc: '最高可达带宽上行速率',
        },
        {
          icon: require('@/assets/remote_files/adv_mount.png'),
          title: '远程挂载',
          desc: '挂载远程文件到本地',
        },
        {
          icon: require('@/assets/remote_files/adv_perm.png'),
          title: '权限控制',
          desc: '权限管理仅限本地',
        },
        {
          icon: require('@/assets/remote_files/adv_secure.png'),
          title: '安全传输',
          desc: '仅通过加密通道传输',
        },
      ],
      // 工作原理 3 步：开启文件访问 → 发起访问 → 远程文件
      flowList: [
        {
          img: require('@/assets/remote_files/flow2.png'),
          title: '开启文件访问',
          desc: '设备本地授权远程文件路径并启用远程文件功能',
        },
        {
          img: require('@/assets/remote_files/flow3.png'),
          title: '发起访问',
          desc: '客户端进入远程文件功能点击设备即可查看',
        },
        {
          img: require('@/assets/remote_files/flow4.png'),
          title: '远程文件',
          desc: '预览、下载、挂载',
        },
      ],
      // 使用方式插图用 SVG（透明背景，深色渐变能保留，PNG 导出会发白）
      usageList: [
        {
          img: require('@/assets/remote_files/usage_card1.png'),
          title: '文件浏览访问',
          desc: '通过客户端浏览目标设备的文件，随时查看与管理',
        },
        {
          img: require('@/assets/remote_files/usage_card2.png'),
          title: '远程挂载到本地',
          desc: '在Windows / Mac客户端将远程共享文件夹挂载到本地，像本地磁盘一样使用',
        },
        {
          img: require('@/assets/remote_files/usage3.png'),
          title: '跨设备传输协作',
          desc: '在不同设备之间上传，下载，复制与整理文件，实现高效协作',
        },
      ],
      // 应用场景 4 卡
      sceneList: [
        {
          img: require('@/assets/remote_files/scene1.webp'),
          title: '远程文件',
          desc: '在外访问公司电脑文件，访问家庭照片、视频与文档',
        },
        {
          img: require('@/assets/remote_files/scene2.webp'),
          title: '设计素材同步',
          desc: '访问设计素材与项目文件。随取随用，灵活高效',
        },
        {
          img: require('@/assets/remote_files/scene3.webp'),
          title: '电脑扩容',
          desc: '将远程设备目录挂载成本地磁盘，扩展可用存储空间。',
        },
        {
          img: require('@/assets/remote_files/scene4.webp'),
          title: '出差取文件',
          desc: '出差途中临时访问家中或办公室电脑里的资料。',
        },
      ],
    }
  },
  methods: {
    goDownload: function () {
      if (this.$route.path !== '/download') {
        this.$router.push('/download')
      }
    },
    goDoc: function () {
      window.open('https://iepose.com/helpcenter_v3/')
    },
    // 滚动检查：进入视口的 .move 元素加 move-active，触发入场动画（同首页模式）
    checkInView: function (animatedElements) {
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight
      animatedElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top
        const elementBottom = element.getBoundingClientRect().bottom
        const isInView = elementTop < windowHeight - 100 && elementBottom > 0
        if (isInView) {
          element.classList.add('move-active')
        }
      })
    },
  },
  mounted: function () {
    const animatedElements = document.querySelectorAll('.move')
    // 首屏元素立即检查一次（页面刚加载时尚未触发 scroll，避免首屏内容空白）
    this.$nextTick(() => {
      this.checkInView(animatedElements)
    })
    window.addEventListener('scroll', () => {
      this.checkInView(animatedElements)
    })
  },
}
</script>

<style scoped lang="less">
.remote-files {
  width: 100%;

  .section-title {
    font-size: 40px;
    font-weight: 700;
    color: #1d1f24;
    text-align: center;
  }

  .section-sub {
    margin-top: 12px;
    font-size: 24px;
    line-height: 36px;
    color: #777e90;
    text-align: center;
  }

  .btn-primary {
    width: 160px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #ffffff;
    font-size: 18px;
    border-radius: 8px;
    background: #3772ff;
    cursor: pointer;
  }

  .btn-primary:hover {
    opacity: 0.9;
  }

  /* ---------- 首屏 ---------- */
  .section-banner {
    padding-top: 122px;
    padding-bottom: 70px;
    // 斜向渐变：左上 → 右下
    background: linear-gradient(135deg, #e5edff 0%, #e4ecff 50%, #dfdaff 100%);

    .banner-main {
      width: 1280px;
      margin: 0 auto;
    }

    .banner-row {
      position: relative;
      height: 328px;

      .banner-pic {
        position: absolute;
        right: 0;
        top: -26px;
        width: 610px;
        height: 375px;
        flex-shrink: 0;
      }
    }

    .banner-left {
      width: 610px;
      flex-shrink: 0;
    }

    .banner-title {
      width: fit-content;
      font-size: 64px;
      font-weight: 700;
      line-height: 72px;
      background: linear-gradient(
        90deg,
        #3772ff 0%,
        #aa56ff 35%,
        #ff6838 70%,
        #ff9924 100%
      );
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .banner-subtitle {
      margin-top: 13px;
      font-size: 44px;
      font-weight: 700;
      line-height: 66px;
      color: #1d1f24;
    }

    .banner-desc {
      margin-top: 9px;
      width: 560px;
      font-size: 20px;
      line-height: 29px;
      color: #777e90;
    }

    .banner-btns {
      display: flex;
      margin-top: 33px;
    }

    .btn-ghost {
      margin-left: 16px;
      width: 160px;
      height: 48px;
      line-height: 46px;
      text-align: center;
      font-size: 18px;
      color: #3772ff;
      border: 1px solid #3772ff;
      border-radius: 8px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .btn-ghost:hover {
      background: rgba(55, 114, 255, 0.08);
    }

    .banner-features {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 80px;
      height: 120px;
      padding: 0 67px;
      background: rgba(255, 255, 255, 0.4);
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 20px;
      box-sizing: border-box;
      // 毛玻璃悬浮条：半透明白 + 背景模糊
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
      box-shadow: 0 8px 24px rgba(23, 33, 94, 0.06);
    }

    .feature-item {
      display: flex;
      align-items: center;

      .feature-icon {
        width: 60px;
        height: 60px;
      }

      .feature-text {
        margin-left: 12px;

        .feature-title {
          font-size: 24px;
          font-weight: 700;
          line-height: 36px;
          color: #1d1f24;
        }

        .feature-sub {
          margin-top: 2px;
          font-size: 16px;
          line-height: 24px;
          color: #57576c;
        }
      }
    }
  }

  /* ---------- 核心能力 ---------- */
  .section-adv {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #ffffff;
    box-sizing: border-box;

    .adv-main {
      width: 1280px;
      margin: 0 auto;
    }

    .adv-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }

    .adv-card {
      width: 240px;
      min-height: 220px;
      padding: 33px 24px 0;
      background: #f7f9fe;
      border-radius: 16px;
      box-sizing: border-box;

      .adv-icon {
        width: 48px;
        height: 48px;
        display: block;
      }

      .adv-title {
        margin-top: 24px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
      }

      .adv-desc {
        margin-top: 10px;
        font-size: 14px;
        line-height: 21px;
        color: #777e90;
      }
    }
  }

  /* ---------- 工作原理 ---------- */
  .section-flow {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #f7f9fe;
    box-sizing: border-box;

    .flow-main {
      width: 1280px;
      margin: 0 auto;
    }

    .flow-grid {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 50px;
    }

    .flow-card {
      // 340 宽卡 + 139 箭头间距，凑满 1280 内容区
      width: 340px;
      padding: 30px 30px 0;
      // 卡片固定 300 高，文案行数不同也能等高
      min-height: 300px;
      background: #ffffff;
      border-radius: 20px;
      box-shadow: 0 4px 30px 0 rgba(55, 114, 255, 0.05);
      box-sizing: border-box;

      .flow-top {
        height: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        img {
          width: 160px;
          height: 140px;
          object-fit: contain;
        }
      }

      .flow-title {
        margin-top: 20px;
        font-size: 24px;
        font-weight: 700;
        line-height: 34px;
        color: #1d1f24;
        text-align: center;
      }

      .flow-desc {
        // 底部留白 14px：两行文案时内容 286，配合 min-height 300 全卡等高；40px 会把卡顶超
        margin: 10px auto 14px;
        font-size: 16px;
        line-height: 26px;
        color: #777e90;
        text-align: center;
      }
    }

    .flow-arrow {
      // 相邻卡间距 139px，箭头 30x30 居中
      width: 139px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }

  /* ---------- 使用方式（深色区） ---------- */
  .section-usage {
    padding-top: 60px;
    padding-bottom: 82px;
    background: linear-gradient(180deg, #1d1f24 0%, #192238 100%);
    box-sizing: border-box;

    .usage-main {
      width: 1280px;
      margin: 0 auto;
    }

    .gradient-title {
      background: linear-gradient(180deg, #ffffff 0%, #99a0ae 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .usage-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }

    .usage-card {
      width: 400px;
      padding-bottom: 36px;
      background: linear-gradient(180deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0) 100%);
      border-radius: 20px;
      box-sizing: border-box;

      .usage-illus {
        width: 400px;
        height: 280px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        overflow: hidden;

        img {
          display: block;
          flex-shrink: 0;
          // 插图按 400 宽等比显示（第三张为 400x220）
          width: 400px;
        }
      }

      .usage-title {
        margin-top: 20px;
        // 文本左右间距 30 / 24
        padding: 0 24px 0 30px;
        font-size: 30px;
        font-weight: 700;
        line-height: 42px;
        color: #ffffff;
        text-align: left;
      }

      .usage-desc {
        margin-top: 10px;
        // 左 30 右 24
        padding: 0 24px 0 30px;
        font-size: 16px;
        line-height: 26px;
        color: #b1b5c4;
        text-align: left;
      }
    }
  }

  /* ---------- 应用场景 ---------- */
  .section-scene {
    padding-top: 60px;
    padding-bottom: 82px;
    background: #ffffff;
    box-sizing: border-box;

    .scene-main {
      width: 1280px;
      margin: 0 auto;
    }

    .scene-grid {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }

    .scene-card {
      // 4 卡布局：卡宽 302，间距 24
      width: 302px;
      background: #ffffff;
      box-sizing: border-box;

      .scene-img-wrap {
        height: 180px;
        border-radius: 20px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          }
      }

      .scene-title {
        margin-top: 19px;
        // 文本左右 12px
        padding: 0 12px;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        color: #1d1f24;
      }

      .scene-desc {
        margin-top: 13px;
        // 文本左右 12px
        padding: 0 12px;
        font-size: 14px;
        line-height: 21px;
        color: #777e90;
      }
    }
  }

  /* ---------- 底部 CTA ---------- */
  .section-cta {
    position: relative;
    padding-top: 67px;
    padding-bottom: 60px;
    background: #3772ff;
    overflow: hidden;
    box-sizing: border-box;

    .cta-overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      mix-blend-mode: overlay;
      opacity: 0.6;
      pointer-events: none;
    }

    .cta-main {
      position: relative;
      width: 1280px;
      margin: 0 auto;
      text-align: center;
    }

    .cta-title {
      font-size: 40px;
      font-weight: 700;
      line-height: 60px;
      color: #ffffff;
    }

    .cta-sub {
      margin-top: 12px;
      font-size: 18px;
      color: #ffffff;
    }

    .cta-btn {
      margin: 26px auto 0;
      width: 168px;
      height: 48px;
      line-height: 48px;
      font-size: 19px;
      background: #ffffff;
      color: #3772ff;
    }
  }

  /* ---------- 滚动入场动画（同首页模式） ---------- */
  .move {
    opacity: 0;
    transform: translateY(50px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  }
  .move-active {
    opacity: 1;
    transform: translateY(0);
  }
  /* 为不同元素设置不同的延迟，创建层次感 */
  .delay-100 {
    transition-delay: 0.1s;
  }
  .delay-200 {
    transition-delay: 0.2s;
  }
  .delay-300 {
    transition-delay: 0.3s;
  }
}
</style>
